import React from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReactTable from "react-table";
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import {TableConfig} from '../../utils/appConfig';

const log = new Logger('PAYMENTS_DETAILS', LOG_LEVELS.DEBUG);

class PaymentsDetails extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        log.debug('render(): ', this.props);

        const columns = [
            {
                Header: props => <span><LanguageStringResolver string='Payments_Received'/></span>,
                accessor: 'received',
                filterable:true
            },
            {
                id: 'amount',
                Header: props => <span><LanguageStringResolver string='Payments_Amount'/></span>,
                accessor: d =>  <FormattedCurrencyValue value={d.amount} />,
                filterable:true,
                filterMethod: (filter, row, column) => {
                    return `${Number.parseFloat(row && row._original[filter.id]).toFixed(2)}`.includes(`${filter.value}`);
                },
                sortMethod: (a, b, desc) => {
                    // force null and undefined to the bottom
                    a = a && a.props ? a.props.value: a;
                    b = b && b.props ? b.props.value: b;
                    a = Number.parseFloat(a, 10);
                    b = Number.parseFloat(b, 10);
                    a = Number.isNaN(a) ? -Infinity :  a;
                    b = Number.isNaN(b) ? -Infinity : b;        
                    // Return either 1 or -1 to indicate a sort priority
                    if (a > b) {
                        return 1;
                    }
                    if (a < b) {
                        return -1;
                    }
                    // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
                    return 0;
                },
                className: "text-align-right"
            }
        ]

            const NoDataComponent = props => (
                <NoData
                  noDataText="paymentsDetails_NoData"
                  {...props}
                />
              )

            return (
                <div>
                    <ReactTable
                        minRows={0}
                        maxRows={0}
                        data={this.props.data}
                        loading={this.props.loading}
                        columns={columns}
                        onFetchData={this.props.onFetchData}
                        showPageJump={false}
                        pages={this.props.pages}
                        NoDataComponent={NoDataComponent}
                        className={this.props.data && this.props.data.length === 0 ? 'mb15 hide-header' : 'mb15'}
                        PaginationComponent={Pagination}
                        showPagination={this.props.data && this.props.data.length === 0 ? false : true}
                        defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                        pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    />
                </div>
            )
    }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(PaymentsDetails);